module.exports = __webpack_public_path__ + "static/lenvima-dose-reduction-desktop-3be331717dc227656ba65069b75263de.png";